import {UI, registerStyle} from "../../../stem-core/src/ui/UI";

import {LoadingSpinner, LoadingSpinnerStyle} from "../../ui/LoadingSpinner";
import {styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";


export class MerchantLoadingSpinnerStyle extends LoadingSpinnerStyle {
    @styleRuleInherit
    loadingSpinner = {
        ">:last-child g": {
            fill: this.themeProps.MERCHANT_SPINNER_LOGO,
        },
        background: this.themeProps.MERCHANT_SPINNER_BACKGROUND,

        // These are for Safari border bugs during animations.
        "-webkit-backface-visibility": "hidden",
        "-moz-backface-visibility": "hidden",
        "-webkit-transform": "translate3d(0, 0, 0)",
        "-moz-transform": "translate3d(0, 0, 0)",
    };
}

@registerStyle(MerchantLoadingSpinnerStyle)
export class MerchantLoadingSpinner extends LoadingSpinner {
    onMount() {
        super.onMount();

        this.attachListener(Dispatcher.Global, "killAllPopups", () => this.constructor.hide());
    }
}
